import React from 'react';
import { ALL_SOURCES, Select } from '@fabric-ui/components';
import { emptyArray, emptyObject } from '@fabric-ui/utils';
import { IconVariant, ItemWithLogo } from './ItemWithLogo';

interface DataSourceSelectProps {
  filterValue?: string[] | string;
  getValueFunc?: (option: any) => string;
  onChange: (value: string[]) => void;
  options: { name: string }[];
  selectProps?: object /* SelectProps */;
  size?: 'small' | 'xSmall' | 'medium';
  label?: string;
  variant?: string;
  isMultiple?: boolean;
}

function DataSourceSelect({
  filterValue = emptyArray,
  getValueFunc = ({ name, value }) => name || value,
  onChange,
  options,
  selectProps = emptyObject,
  size = 'small',
  label = 'Source',
  variant = 'filter',
  isMultiple = true,
}: DataSourceSelectProps) {
  return (
    <Select
      size={size}
      label={label}
      value={filterValue}
      onChange={val => onChange(val)}
      options={options}
      renderOption={({ name, value, title }) =>
        value === ALL_SOURCES ? (
          title
        ) : (
          <ItemWithLogo variant={IconVariant.sourcesMapByName} type={name as string} textStyle={{ overflow: 'auto' }} />
        )
      }
      getLabelFunc={({ name, title }: any) => name || title}
      getValueFunc={getValueFunc}
      isMultiple={isMultiple}
      variant={variant as any}
      {...selectProps}
    />
  );
}

export default DataSourceSelect;
